<template>
<div class="container">
<mt-loadmore :bottom-method="loadBottom" bottomDropText="加载更多" :auto-fill="false" :bottom-all-loaded="allLoaded" ref="loadmore">

<div class="row title" v-if="hot">
	套餐推荐
</div>
<div class="row good">
	<div class="col-5" v-for="v in hot" @click="detail(v)" :key="v.id">
		<img :src="picurl+v.pic" alt="商品图片"/>
		<h4>{{v.name}}</h4>
		<p class="pp">
		<span class="price">¥{{v.price/100}}</span>
		<span class="oprice" v-show="v.oprice>0">¥{{v.oprice/100}}</span>
		</p>
	</div>
</div>

<div class="row title" v-if="cardlist.length>0">
	优惠券
</div>
<div class="row card-box" v-if="cardlist.length>0">
   <card :card="cardlist" :type="3" @select="select_card"></card>	
</div>


<div class="row title" v-if="list">
	热门套餐
</div>
<div class="row good">
	<div class="col-5" v-for="v in list" @click="detail(v)" :key="v.id">
		<img :src="picurl+v.pic" alt="商品图片"/>
		<h4>{{v.name}}</h4>
		<p class="pp">
		<span class="price">¥{{v.price/100}}</span>
		<span class="oprice" v-show="v.oprice>0">¥{{v.oprice/100}}</span>
		</p>
	</div>
</div>

<div class="row center" style="padding:1rem;" v-show="!allLoaded">
   <mt-button size="small" @click="loadBottom">点击查看更多</mt-button>
</div>
<nomore v-show="allLoaded"></nomore>

</mt-loadmore>

</div>
</template>

<style scoped>
.good img{width:90%;margin:2% 5%;}
.title{font-size: 1.2rem;padding:.5rem;font-weight: 600;}
h4{height:3.3rem;overflow: hidden;font-weight: 500;}	
.price{color:red;font-size: 1.2rem;}
.oprice{color:#adadad;text-decoration:line-through;}
.pp{padding-left:.5rem;}
.nomore{padding:1rem;}

.card-box{border-top:1px dashed #ddd;border-bottom:1px dashed #ddd;margin:.5rem 0 1.5rem;}
</style>

<script>
import nomore from "../../lib/nomore.vue";
import card from "../../lib/card.vue";


export default {
	data:function(){
		return {
          hot:"",
          list:"",
          picurl:picurl,
          allLoaded:false,
		  count:0,
		  cardlist:[],
		}
	},
	components:{nomore,card},
	created:function(){
		this.init();
		mydata.header=true;
        if(mydata.position>0){
        	fun.toy(mydata.position);
		}
		this.get_card();
	},
	methods:{
	  init:function(){
        var _this=this;
        if(fun.cache(fun.url())){
			var re=fun.cache(fun.url());
			console.log(re)
        	this.hot=re.hot;
        	this.list=re.list;
        	if(this.list.length>=re.count){
        		this.allLoaded=true;
        	}
        	return;
        }
        fun.post(mydata.api+"Api/mall",{},function(d){
        	console.log(d);
        	if(d.status==1){
        		_this.hot=d.info.hot;
        		_this.list=d.info.list;
        		_this.count=d.info.count;
        		if(d.info.list.length<6){
        			_this.allLoaded=true;
        		}
        		fun.cache(fun.url(),d.info);
        	}else{
        		_this.$toast(d.info);
        	}
        })
	  },
	  get_card:function(){
		var _this=this;
		fun.post(mydata.api+"Api/get_freecard",{},function(d){
			fun.log(d)
			if(d.status==1){
				var list=d.info;
				var nlist=[];
				for(var i=0,len=list.length;i<len;i++){
					if(list[i]['isget']==false){nlist.push(list[i]);}
				}
				if(nlist.length>0){
					_this.cardlist=nlist;
				}
			}
		})
	  },
	  select_card:function(v){
		 var _this=this;
		 fun.post(mydata.api+"Member/add_card",v,function(d){
			 fun.log(d)
			 if(d.status==1){
				 v.isget=true;
			 }else{
				 _this.$toast(d.info);
			 }
		 })
	  },
	  loadBottom:function(){
	  	var data={
	  		len:this.list.length,
	  	}
	  	var _this=this;
	  	fun.post(mydata.api+"Api/mallmore",data,function(d){
	  		console.log(d);
	  		_this.$refs.loadmore.onBottomLoaded();
	  		if(d.status==1){
	  			_this.list=_this.list.concat(d.info);
	  			if(d.info.length<6){
	  				_this.allLoaded=true;
	  			}
	  			fun.cache(fun.url(),{list:_this.list,hot:_this.hot,count:_this.count});
	  		}else{
	  			_this.$toast(d.info);
	  			_this.allLoaded=true;
	  		}
	  	})
	  },
	  detail:function(v){
         fun.saveposition();
         fun.link("/mall/detail/code/"+v.gcode);
	  }

	}
}	
</script>


// WEBPACK FOOTER //
// src/components/mall/mall.vue